<template>
  <div class="people-card">
    <GenericCard>
      <template #image>
        <div style="width: 100%; height: 200px; background-color: lightgray" />
      </template>
      <template #body>
        <div class="role placeholder-glow">
          <span class="placeholder col-3"></span>
        </div>
        <h4 class="name placeholder-glow">
          <span class="placeholder col-5"></span>
        </h4>
        <div class="location placeholder-glow">
          <span class="placeholder col-3"></span>
        </div>
      </template>
    </GenericCard>
  </div>
</template>
